import { lazy } from 'react'
import { Routes, Route } from 'react-router-dom'

import { MainLayout } from 'components/MainLayout'
import { NoAccessGuard } from 'components/NoAccessGuard'
import { WorkflowsRedirect } from 'pages/DocumentAnalysis/WorkflowsRedirect'
import { ErrorAuthFailed } from 'pages/ErrorAuthFailed'
import { ErrorPageNotFound } from 'pages/ErrorPageNotFound'
import { Print } from 'pages/Print'

const FrontPage = lazy(() =>
  import('./pages/FrontPage').then(module => ({ default: module.FrontPage })),
)

const Conversation = lazy(() =>
  import('./pages/Conversation').then(module => ({
    default: module.Conversation,
  })),
)

const DocumentAnalysis = lazy(() =>
  import('./pages/DocumentAnalysis').then(module => ({
    default: module.DocumentAnalysis,
  })),
)

const DocumentAnalysisOverview = lazy(() =>
  import('./pages/DocumentAnalysisOverview').then(module => ({
    default: module.DocumentAnalysisOverview,
  })),
)

const FrequentlyAskedQuestions = lazy(() =>
  import('./pages/FrequentlyAskedQuestions').then(module => ({
    default: module.FrequentlyAskedQuestions,
  })),
)

const PromptEntry = lazy(() =>
  import('./pages/PromptEntry').then(module => ({
    default: module.PromptEntry,
  })),
)

const AuthReturn = lazy(() =>
  import('./pages/AuthReturn').then(module => ({
    default: module.AuthReturn,
  })),
)

const AdminLayout = lazy(() =>
  import('./pages/Admin/AdminLayout').then(module => ({
    default: module.AdminLayout,
  })),
)

const AdminFrontpage = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminFrontpage,
  })),
)

const AdminEncryption = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminEncryption,
  })),
)

const AdminSidekiq = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminSidekiq,
  })),
)

const AdminUsers = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminUsers,
  })),
)

const AdminUser = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminUser,
  })),
)

const AdminFAQ = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminFAQ,
  })),
)

const AdminFAQItems = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminFAQItems,
  })),
)

const AdminFAQItem = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminFAQItem,
  })),
)

const AdminServiceMessage = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminServiceMessage,
  })),
)

const AdminServiceMessages = lazy(() =>
  import('./pages/Admin').then(module => ({
    default: module.AdminServiceMessages,
  })),
)

export const AppRoutes = () => (
  <Routes>

    <Route path="/auth/failure" element={<ErrorAuthFailed />} />
    <Route path="/auth_return" element={<AuthReturn />} />

    <Route
      path="/"
      element={(
        <NoAccessGuard>
          <MainLayout />
        </NoAccessGuard>
      )}
    >
      <Route index element={<FrontPage />} />
      <Route path="conversations/:conversationId" element={<Conversation />} />
      <Route path="/document_analysis" element={<DocumentAnalysisOverview />} />
      <Route path="/document_analysis/:slug" element={<DocumentAnalysis />} />
      <Route path="/workflows" element={<WorkflowsRedirect />} />
      <Route path="/workflows/examples/:slug" element={<WorkflowsRedirect isExamplesPage />} />
      <Route path="/workflows/:slug" element={<WorkflowsRedirect />} />
      <Route path="/prompt_entry/:slug" element={<PromptEntry />} />
    </Route>

    <Route path="/help" element={<FrequentlyAskedQuestions />} />
    <Route path="/print" element={<Print />} />

    <Route
      path="/admin"
      element={(
        <NoAccessGuard>
          <AdminLayout />
        </NoAccessGuard>
      )}
    >
      <Route index element={<AdminFrontpage />} />
      <Route path="/admin/encryption" element={<AdminEncryption />} />
      <Route path="/admin/users" element={<AdminUsers />} />
      <Route path="/admin/users/:uuid" element={<AdminUser />} />
      <Route path="/admin/help" element={<AdminFAQ />} />
      <Route path="/admin/help/:faqGroupId" element={<AdminFAQItems />} />
      <Route path="/admin/help/:faqGroupId/faqItems/:faqItemId" element={<AdminFAQItem />} />
      <Route path="/admin/serviceMessages" element={<AdminServiceMessages />} />
      <Route path="/admin/serviceMessages/new" element={<AdminServiceMessage isNew />} />
      <Route path="/admin/serviceMessages/:serviceMessageId" element={<AdminServiceMessage />} />
      <Route path="/admin/sidekiqRedirect" element={<AdminSidekiq />} />
      <Route path="*" element={<ErrorPageNotFound />} />
    </Route>
    <Route path="*" element={<ErrorPageNotFound />} />
  </Routes>
)
